import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'
import Select from 'react-select'

import { GET, POST, httpOk } from 'helpers/api'

function QuickElementModal({ show, onClose, onCreated, defaultValues = {}, defaultName = '' }) {
	const { t } = useTranslation()
	const [data, setData] = useState({ unit_id: 1 })
	const [units, setUnits] = useState([])

	async function createElement(e) {
		e.preventDefault()

		const response = await POST('/elements', { ...data, ...defaultValues }, { loader: true })
		if (httpOk(response)) {
			onCreated?.(response.data)
			setData({ unit_id: 1 })
			onClose?.()
		}
	}

	async function getUnits() {
		const response = await GET('/elements-units')
		if (httpOk(response)) setUnits(response.data)
	}

	useEffect(() => {
		if (show && !units.length) getUnits()
		// при открытии подставляем название (например внешнее название из документа)
		if (show) setData({ unit_id: 1, name: defaultName })
		if (!show) setData({ unit_id: 1 })
	}, [show]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal show={show} animation={false} centered
			dialogClassName="update-modal-width"
			onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title>{t('create')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<form onSubmit={createElement} autoComplete="off">
					<div className="form-group w-100">
						<label>{t('name2')}<span className="required-mark">*</span></label>
						<input type="text" className="form-control"
							value={data.name ?? ''}
							onChange={(e) => setData({ ...data, name: e.target.value })} />
					</div>
					<div className="form-group w-100">
						<label>{t('unit')}<span className="required-mark">*</span></label>
						<Select
							options={units}
							value={units.find(option => option.id === data.unit_id)}
							onChange={(option) => setData({ ...data, unit_id: option ? option.id : null })}
							placeholder=""
							noOptionsMessage={() => t('list_empty')}
							getOptionLabel={(option) => option.name}
							getOptionValue={(option) => option.id}
						/>
					</div>
					<div className="form-group w-100">
						<label>{t('weight_one_unit_kg')}</label>
						<input type="number" className="form-control"
							value={data.quantity ?? ''}
							onChange={(e) => setData({ ...data, quantity: e.target.value })} />
					</div>
					<div className="d-flex w-100 mt-3 gap-2">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={onClose}>
							{t('cancel')}
						</button>
						<button type="submit" className="btn btn-primary w-100"
							disabled={!(data.name && data.unit_id)}>
							{t('save')}
						</button>
					</div>
				</form>
			</Modal.Body>
		</Modal>
	)
}

export default QuickElementModal
